export const MAX_RECENT_TICKET_SEARCHES = 8;

export function recentTicketSearchesKey(userId) {
	return `ticketRecentSearches:${userId}`;
}

export function normalizeRecentTicketSearch(term) {
	return String(term || "")
		.trim()
		.replace(/\s+/g, " ");
}

export function readRecentTicketSearches(userId) {
	if (!userId) return [];

	try {
		const raw = localStorage.getItem(recentTicketSearchesKey(userId));
		if (!raw) return [];

		const parsed = JSON.parse(raw);
		if (!Array.isArray(parsed)) return [];

		return parsed
			.map(normalizeRecentTicketSearch)
			.filter(Boolean)
			.slice(0, MAX_RECENT_TICKET_SEARCHES);
	} catch {
		return [];
	}
}

export function writeRecentTicketSearches(userId, terms) {
	if (!userId) return [];

	const next = (Array.isArray(terms) ? terms : [])
		.map(normalizeRecentTicketSearch)
		.filter(Boolean)
		.filter(
			(term, index, list) =>
				list.findIndex((item) => item.toLowerCase() === term.toLowerCase()) ===
				index
		)
		.slice(0, MAX_RECENT_TICKET_SEARCHES);

	try {
		localStorage.setItem(recentTicketSearchesKey(userId), JSON.stringify(next));
	} catch {
		return next;
	}

	return next;
}

export function pushRecentTicketSearch(userId, term) {
	const normalized = normalizeRecentTicketSearch(term);
	if (!userId || !normalized) {
		return readRecentTicketSearches(userId);
	}

	const current = readRecentTicketSearches(userId);
	const next = [
		normalized,
		...current.filter((item) => item.toLowerCase() !== normalized.toLowerCase()),
	];

	return writeRecentTicketSearches(userId, next);
}

export function removeRecentTicketSearch(userId, term) {
	const normalized = normalizeRecentTicketSearch(term).toLowerCase();
	const next = readRecentTicketSearches(userId).filter(
		(item) => item.toLowerCase() !== normalized
	);
	return writeRecentTicketSearches(userId, next);
}
